import styled from 'styled-components';

export const RemovePlayerWrapper = styled.div`
  position: absolute;
  bottom: 75px;
  left: 0;
  width: 100%;
  padding: 0 5px;
`;

export const RemovePlayerItem = styled.div`
  color: #fff;
  font-weight: 700;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 11px;
  backdrop-filter: blur(60px);
`;

export const RemoveText = styled.div`
  margin-left: 7px;
`;

export const CancelActionText = styled.div`
  margin-right: 12px;
`;
